import { Controller } from "@hotwired/stimulus";

// Copies the text of the `source` target to the clipboard and briefly flips the
// button label to confirm.
export default class extends Controller {
  static targets = ["source", "label"];
  static values = { copiedText: { type: String, default: "Copied" } };

  select() {
    this.sourceTarget.select();
  }

  async copy(event) {
    event.preventDefault();
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent;

    try {
      await navigator.clipboard.writeText(text.trim());
    } catch {
      // Clipboard API unavailable (insecure context): fall back to selecting the text.
      if (this.sourceTarget.select) this.sourceTarget.select();
      document.execCommand("copy");
    }

    if (!this.hasLabelTarget) return;
    const original = this.labelTarget.textContent;
    this.labelTarget.textContent = this.copiedTextValue;
    setTimeout(() => (this.labelTarget.textContent = original), 2000);
  }
}
